import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { routes } from "../../../environments/environment.routes";

export const cameraRequiredGuard = async () => {
  const router = inject(Router);

  const hasCamera = await checkCameraAvailability();
  console.log("[cameraRequiredGuard] hasCamera", hasCamera);
  if (!hasCamera) {
    router.navigate(
      [routes.frontend.scan, routes.frontend.deviceNotSupported],
      { queryParamsHandling: "preserve" },
    );
    return false;
  }

  return true;
};

async function checkCameraAvailability(): Promise<boolean> {
  try {
    console.log("[checkCameraAvailability] navigator", navigator);
    // Check if getUserMedia is supported
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      console.log("[checkCameraAvailability] no media devices or getUserMedia");
      return false;
    }

    // Check if we can enumerate devices
    const devices = await navigator.mediaDevices.enumerateDevices();
    console.log("[checkCameraAvailability] devices", devices);
    const hasVideoInput = devices.some(
      (device) => device.kind === "videoinput",
    );

    if (!hasVideoInput) {
      console.log("[checkCameraAvailability] no video input");
      return false;
    }

    // Try to get camera access (this might prompt user for permission)
    try {
      console.log("[checkCameraAvailability] getting user media");
      const stream = await navigator.mediaDevices.getUserMedia({
        video: {
          facingMode: "environment", // Prefer back camera
        },
      });
      console.log("[checkCameraAvailability] got user media", stream);
      // Stop the stream immediately as we just needed to test access
      stream.getTracks().forEach((track) => track.stop());

      return true;
    } catch (error) {
      console.error("Camera check failed:", error);
      return false;
    }
  } catch (error) {
    console.error("Camera check failed:", error);
    return false;
  }
}
